module.exports = __webpack_public_path__ + "img/1526178528.d7b08ab4.jpg";